import { voucherSlice } from './slice'

export const {
  // Campaigns
  setCampaignValue,
  resetCampaignsState,

  // Create Campaign
  setCreateCampaignValue,
  resetCreateCampaignsState,

  // Create Discount Voucher
  setCreateDiscountVoucheralue,
  resetCreateDiscountVoucherState

} = voucherSlice.actions

